import { type AxiosResponse } from 'axios'
import api from '../utils/api'

export interface GlobalSettings {
  globalSettingId: string
  timezone: string | null
  crossListing: string | null
  crossListingOptions: string[]
  enableSisUserOverride: boolean | null
  isCustomBrandingEnabled: boolean | null
  enableRepeatPerInstructorMerging: boolean | null
  defaultCognitoProvisioned: boolean | null
  isLiveReportsEnabled: boolean | null
}

export type GlobalSettingsPatch = Partial<Omit<GlobalSettings, 'globalSettingId' | 'crossListingOptions'>>

const getGlobalSettings = async (): Promise<AxiosResponse<GlobalSettings>> =>
  await api.get('/api/global-settings/')

const patchGlobalSettings = async (
  data: GlobalSettingsPatch
): Promise<AxiosResponse<GlobalSettings>> =>
  await api.patch('/api/global-settings/', data)

export default { getGlobalSettings, patchGlobalSettings }
